import React from 'react'
import Badge from 'react-bootstrap/Badge'
import Button from 'react-bootstrap/Button'


class Tacossv extends React.PureComponent {
  render() {
    return (
      <div>

        <p>
          SV Tacossv Component
        </p>
      
       
     <h1>
        Blue Taco 
        <Badge bg="secondary" as={Button}>
        SV Tacossv Badge
        </Badge>
      </h1>
        
      </div>
    )
  }
}

export default Tacossv
